module.exports = __webpack_public_path__ + "img/avatar_default.50e21b1f.png";